import type { ReactNode } from 'react';

const FlameIcon = () => (
  <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2c1 3-3 4-3 8a3 3 0 0 0 6 0c0-1-.5-2-1-3 2 1 3 3 3 6a5 5 0 0 1-10 0c0-5 3-6 5-11z" />
  </svg>
);

const StarIcon = () => (
  <svg width={14} height={14} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.7 7-6.3-3.9L5.7 21l1.7-7L2 9.2l7.1-.6z" />
  </svg>
);

const Chip = ({ icon, children }: { icon: ReactNode; children: ReactNode }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: '#fdece0',
      color: 'var(--ember-dark)',
      fontFamily: 'var(--font-vi)',
      fontWeight: 700,
      fontSize: 14,
      padding: '6px 12px',
      borderRadius: 999,
      whiteSpace: 'nowrap',
    }}
  >
    {icon}
    {children}
  </span>
);

/** Component DUY NHẤT được dùng màu Ember — Ember chỉ dành cho gamification. */
export function StreakXpBadge({ streak, xp, level }: { streak?: number; xp?: number; level?: number | string }) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {streak != null && <Chip icon={<FlameIcon />}>{streak} ngày</Chip>}
      {xp != null && <Chip icon={<StarIcon />}>{xp} XP</Chip>}
      {level != null && <Chip icon="Lv">{level}</Chip>}
    </div>
  );
}
